import { PROCESS_STEPS } from "../../lib/site-data";

export default function Process() {
    return (
        <section className="relative py-24 md:py-32 border-b border-white/5" data-testid="process-section">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="mb-12 md:mb-16">
                    <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                        Süreç
                    </p>
                    <h2 className="font-display text-3xl md:text-5xl text-white tracking-tight max-w-2xl text-balance">
                        Kişisel değerlendirmeden takibe kadar
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 relative">
                    <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-cyan-400/30 to-transparent"></div>
                    {PROCESS_STEPS.map((step) => (
                        <div
                            key={step.n}
                            className="relative"
                            data-testid={`process-step-${step.n}`}
                        >
                            <div className="relative z-10 w-12 h-12 rounded-full bg-[#0A0A0A] border border-cyan-400/40 flex items-center justify-center mb-5 shadow-[0_0_20px_rgba(0,240,255,0.2)]">
                                <span className="font-mono text-xs text-cyan-300">{step.n}</span>
                            </div>
                            <h3 className="font-display text-lg text-white mb-2">{step.title}</h3>
                            <p className="text-sm text-zinc-400 leading-relaxed">{step.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
